import { atom } from 'jotai';
import type { AutoMatchDecisionFilters } from './types';

export const EMPTY_FILTERS: AutoMatchDecisionFilters = {
  outcome: '',
  suppressionReason: '',
  reversal: '',
  countyIds: [],
  after: '',
  before: '',
  search: '',
  sortBy: 'createdAt',
  sortDir: 'desc',
  page: 1,
  perPage: 25,
};

// Filter, sort and pagination state; the decisions query in hooks.ts keys off it.
export const decisionFiltersAtom =
  atom<AutoMatchDecisionFilters>(EMPTY_FILTERS);
